module.exports = __webpack_public_path__ + "static/media/SimplePromptHsbc.f5968fdf.png";